import { Component, computed, inject } from '@angular/core'
import { DecimalPipe, NgOptimizedImage } from '@angular/common'
import { RouterLink } from '@angular/router'

import { Dialog } from '@angular/cdk/dialog'
import { Overlay } from '@angular/cdk/overlay'

import { ROLES } from '@core/data/models'
import { AppStore } from '@core/store'
import { NotificationsPanel, NotificationsStore } from '@features/notifications'
import { Avatar, Icon } from '@shared/ui'

@Component({
  selector: 'site-header',
  imports: [NgOptimizedImage, DecimalPipe, RouterLink, Icon, Avatar],
  templateUrl: './header.html'
})
export class Header {
  readonly #dialog = inject(Dialog)
  readonly #overlay = inject(Overlay)

  protected readonly store = inject(AppStore)
  protected readonly notifications = inject(NotificationsStore)

  protected user = computed(() => this.store.currentUser())

  /** El ejecutivo no gana ni redime monedas: no lleva saldo. */
  protected readonly showsBalance = computed(() => this.user()?.role !== ROLES.EXECUTIVE)

  /** El contador vive en el header, así que la carga arranca aquí. */
  constructor() {
    void this.notifications.load()
  }

  /** El panel entra desde la derecha y ocupa el alto completo. */
  protected openNotifications(): void {
    this.#dialog.open(NotificationsPanel, {
      panelClass: 'side-panel',
      positionStrategy: this.#overlay.position().global().right().top(),
      hasBackdrop: true
    })
  }

  protected logout(): void {
    void this.store.logout()
  }
}
